"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableWithNoData = function TableWithNoData(_ref) {
  var noDataMessage = _ref.noDataMessage,
      columns = _ref.columns;
  if (!noDataMessage) return null;
  return /*#__PURE__*/_react.default.createElement("tr", {
    className: _constants.classes.row
  }, /*#__PURE__*/_react.default.createElement("td", {
    className: "".concat(_constants.classes.expandedCellRender, " ").concat(_constants.classes.render),
    colSpan: (columns === null || columns === void 0 ? void 0 : columns.length) || 1
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.noDataFound
  }, noDataMessage)));
};

TableWithNoData.propTypes = {
  noDataMessage: _propTypes.default.string,
  columns: _propTypes.default.arrayOf(_propTypes.default.object)
};
var _default = TableWithNoData;
exports.default = _default;